// Floating wallet balance chip in the NavBar.
//
// Reads the real balance from the wallet module so a bet debit or a
// win credit lands on every page that mounts the NavBar.
//
// Visual shape mirrors the in-game wallet pill (Ludo / X&O / Carrom
// share the same coin artwork):
//   - The pill itself stays the small NavBar-friendly size — same
//     overall footprint as before, no chrome shift.
//   - The coin sticks out top, bottom, and left of the pill (it's
//     ~32 px while the pill is 28 px and there's a -4 px left margin),
//     producing the "3-D coin sitting on the left edge of the bar"
//     feel the game UIs have. NO left padding inside the pill — the
//     coin is the leftmost thing the eye lands on.
//   - The pill is now a <Link> to /wallet so a tap on the balance
//     opens the wallet page. Per spec there is intentionally no "+"
//     add-money button here — the whole pill is the affordance.
//
// The coin asset lives at /player/coin.png (NOT /games/<id>/Coin.png)
// — see /public/player/README.md for why player-chrome assets are
// kept in their own folder and not shared with per-game art.
import { Link } from 'react-router-dom';
import { useWallet } from '../lib/wallet';

export default function WalletChip() {
  const { balance, loading } = useWallet();
  const display = loading
    ? '…'
    : balance.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  return (
    <Link
      to="/wallet"
      aria-label="Open wallet"
      title={loading ? 'Loading wallet…' : `Balance: ₹${display}`}
      className="inline-flex items-center gap-1 h-7 pl-0 pr-3 rounded-full
                 bg-gradient-to-br from-brand-400 to-brand-600 text-black
                 border border-brand-600/60 shadow-md font-bold text-sm
                 active:scale-[0.97] transition select-none"
    >
      {/* 32-px coin on a 28-px pill + -4 px left pull → coin protrudes
          ~2 px above and below, ~4 px to the left. Same trick the game
          UIs use for the "3-D coin sitting on the bar" look. */}
      <img
        src="/player/coin.png"
        alt=""
        aria-hidden
        draggable={false}
        className="w-8 h-8 -ml-1 shrink-0 drop-shadow-[0_2px_4px_rgba(0,0,0,0.35)]"
      />
      <span className="tabular-nums leading-none">{display}</span>
    </Link>
  );
}
